// Transfer modal steps
export const STEPS = {
  FORM: 1,
  CONFIRMATION: 2,
  SUCCESS: 3
}

// Transfer configuration
export const TRANSFER_CONFIG = {
  NETWORK_FEE: "0.001 ETH",
  PROCESSING_TIME: "2-5 minutes"
}

// Button styles
export const BUTTON_STYLES = {
  PRIMARY: {
    backgroundColor: "var(--accent-color)",
    borderColor: "var(--accent-color)",
    color: "#000000",
    fontWeight: "500"
  },
  OUTLINE: {
    borderColor: "var(--border-color)",
    color: "var(--text-secondary)",
    backgroundColor: "transparent"
  }
}

// Modal titles
export const MODAL_TITLES = {
  [STEPS.FORM]: "Private Transfers",
  [STEPS.CONFIRMATION]: "Confirm Private Transfer",
  [STEPS.SUCCESS]: "Private Transfer Successful"
}